module.exports = __webpack_public_path__ + "media/images/pla/pla3-70bd1b8bd9cb105afeb088a8c66f715b.jpg";